//Helpers
import { convertToUnit } from 'src/helpers/units_helpers';
import { translateTemplateTitle } from '../template_helpers';
//Types
import type { VirtualComponentInterfaceData, VCInterfaceStatus } from 'src/types/VirtualComponents';

export const updateSimpleWaterValveStatus = (
	interface_data: VCInterfaceStatus[],
	data: VCInterfaceStatus,
	valueData: VirtualComponentInterfaceData,
): void => {
	let hideLabel = true;
	const { role, vcType, config } = data;
	if (role === 'position') {
		data.icon = `fa${valueData.value > 0 ? 's' : 'r'} fa-pipe-valve`;
		data.unit = '%';
		data.step = config?.meta?.ui?.step;
		hideLabel = false;
	} else if (role === 'open') {
		data.icon = 'fa fa-arrow-up';
	} else if (role === 'stop') {
		data.icon = 'fa fa-pause';
	} else if (role === 'close') {
		data.icon = 'fa fa-arrow-down';
	} else if (role === 'has_power') {
		data.icon = `fa fa-plug-circle-${valueData.value ? 'bolt' : 'xmark'}`;
		data.iconColor = valueData.value ? '--color-success' : '--color-danger';
		hideLabel = false;
	} else return;
	if (vcType === 'button' || vcType === null || valueData?.value !== null) {
		interface_data.push({
			...data,
			hasAction: true,
			value:
				translateTemplateTitle(valueData.label) ||
				(vcType === 'button' ? null : convertToUnit(valueData.value, valueData.unit)),
			event: valueData.event !== null ? valueData.event : valueData.value,
			hideLabel,
		});
	}
};
